import { Stack, Typography } from "@mui/material";
import Loader from "components/Atoms/SharedComponents/Loader/Loader";
import ActiveModel from "components/Molecules/users/model/activeModel";
import DeleteModel from "components/Molecules/users/model/deleteModel";
import SuspendModel from "components/Molecules/users/model/suspendModel";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getCustomerDetailsRequest,
  getCustomersRequest,
  updateCustomerRequest,
} from "services/modules/users/customers";
import setAuthToken from "services/modules/utils/handel_api";
import CustomersTemplate from "templates/users/customers";
import { useTranslation } from "react-i18next";

function CustomersPage() {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  setAuthToken(token);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const username = searchParams.get("username");
  const type = searchParams.get("type");

  const list = useSelector((state) => state.customers.customers);
  const count = useSelector((state) => state.customers.count);
  const details = useSelector((state) => state.customers.customer);
  const followings = useSelector((state) => state.customers.followings);
  const followers = useSelector((state) => state.customers.followers);
  const load = useSelector((state) => state.customers.load);
  const currentUser = useSelector(
    (state) => state.authenticate.currentUserProfile,
  );
  const permissions = useSelector(
    (state) => state.authenticate.currentUserProfile.permissions.customers,
  );
  const isSuperAdmin = currentUser?.privilege === "super_admin";

  // const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openActionsModal, setOpenActionsModal] = useState({
    state: false,
    action: false,
    customerId: 0,
  });
  const [selectedRow, setSelectedRow] = useState({});
  const [page, setPage] = useState(1);
  const [filterObj, setFilterObj] = useState(null);

  const handlePageChange = (page) => {
    setPage(page);
    setFilterObj((prev) => {
      return { ...prev, page_number: page };
    });
  };

  const getDetails = async () => {
    const requestData = {
      id: id,
    };
    dispatch(getCustomerDetailsRequest({ ...requestData }));
  };

  const getList = async (filterObj) => {
    const requestData = {
      params: {
        page_size: 10,
        page_number: 1,
        keyword: "",
        sort_by: "id",
        ...filterObj,
      },
    };
    dispatch(getCustomersRequest(requestData));
  };

  // mappedData use for create custom cell to concat multi values or navigate button
  const mappedData = list?.map((data, index) => {
    const isActive = data?.status === "active";
    return {
      ...data,
      is_verified: data?.is_verified
        ? t("customers.verified")
        : t("customers.not_verified"),
      profile_status: (
        <Stack
          sx={{
            p: 0.8,
            borderRadius: "4px",
            backgroundColor: isActive ? "#E1F5E8" : "#FAE3E3",
            width: "fit-content",
          }}
          justifyContent="center"
          alignItems="center"
        >
          <Typography
            sx={{
              color: isActive ? "#29B95F" : "#D20000",
            }}
          >
            {data?.status}
          </Typography>
        </Stack>
      ),
      phone_number: `+${data?.country_code}${data?.phone_number}`,
    };
  });

  const rowData = (data) => {
    setSelectedRow(data);
  };

  const breadcrumbs = [
    {
      active: true,
      path: "/",
      title: t("customers.home"),
    },
    {
      active: !type ? false : true,
      path: "/customers",
      title: t("customers.users_customers"),
    },
    type && {
      active: username ? true : false,
      path: `?type=details&id=${id}`,
      title: type === "details" && t("customers.customer_details"),
    },
    username && {
      active: false,
      title: username && username,
    },
  ];

  const handelSubmit = () => {};

  const filterList = [
    {
      type: "search",
      placeholder: t("customers.search_placeholder"),
      onChange: (value) =>
        setFilterObj((s) => {
          return { ...s, keyword: value?.trim(), page_number: 1 };
        }),
      setFilterObj,
    },
    {
      type: "filter",
      placeholder: t("customers.profile_status"),
      onChange: (value) => {
        setFilterObj((s) => {
          return { ...s, status: value?.label?.toLowerCase(), page_number: 1 };
        });
      },
      options: [
        { id: "active", name: t("customers.active") },
        { id: "suspended", name: t("customers.suspended") },
        { id: "deleted", name: t("customers.deleted") },
      ],
    },
    {
      type: "filter",
      placeholder: t("customers.verification"),
      onChange: (value) => {
        setFilterObj((s) => {
          return { ...s, is_verified: value?.value, page_number: 1 };
        });
      },
      options: [
        { id: true, name: t("customers.verified") },
        { id: false, name: t("customers.not_verified") },
      ],
    },
  ];

  const handleDelete = () => {};

  //list of actions to be displayed when clicked in the 3 dots
  const actionsList = ({ index, data }) => {
    const profileStatus = data?.status;
    return [
      {
        condition: () => {
          return !id;
        },
        click: () => {
          navigate(`?type=details&id=${data?.id}`);
        },
        text: t("customers.view"),
      },
      {
        condition: () => {
          return (
            profileStatus === "active" &&
            (isSuperAdmin || permissions?.can_update)
          );
        },
        click: () => {
          // navigate(`?type=form&id=${data?.id}`);
          setOpenActionsModal({
            state: true,
            customerId: selectedRow?.rowData?.id
              ? selectedRow?.rowData?.id
              : id,
            action: "suspended",
          });
        },
        text: t("customers.suspend"),
      },
      {
        condition: () => {
          return (
            profileStatus === "suspended" &&
            (isSuperAdmin || permissions?.can_update)
          );
        },
        click: () => {
          // navigate(`?type=form&id=${data?.id}`);
          setOpenActionsModal({
            state: true,
            customerId: selectedRow?.rowData?.id
              ? selectedRow?.rowData?.id
              : id,
            action: "active",
          });
        },
        text: t("customers.active"),
      },
      {
        condition: () => {
          return (
            data?.status !== "deleted" &&
            (isSuperAdmin || permissions?.can_delete)
          );
        },
        click: () => {
          setOpenActionsModal({
            state: true,
            customerId: selectedRow?.rowData?.id
              ? selectedRow?.rowData?.id
              : id,
            action: "deleted",
          });
        },
        text: t("customers.delete"),
      },
    ];
  };

  //listing all tags
  useEffect(() => {
    if (filterObj && type !== "details") getList(filterObj);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterObj, type]);

  //details of a single tag
  useEffect(() => {
    if (id && type === "details") getDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, type]);

  const handleUpdateProfileState = () => {
    const action = () => {
      toast.success(
        t("customers.account_updated_success", {
          action: openActionsModal?.action,
        }),
      );
    };
    const requestData = {
      body: {
        profile_status: openActionsModal?.action,
      },
      id: openActionsModal?.customerId,
      action,
    };
    dispatch(updateCustomerRequest({ ...requestData }));
  };
  return (
    <>
      <Loader
        open={
          (load?.loading && load?.type === "list") || load?.type === "details"
        }
      />
      <CustomersTemplate
        filterObj={filterObj}
        setFilterObj={setFilterObj}
        data={mappedData}
        count={count}
        paginationPage={page}
        handlePageChange={handlePageChange}
        rowData={rowData}
        details={details}
        breadcrumbs={breadcrumbs}
        filterList={filterList}
        handelSubmit={handelSubmit}
        actionsList={actionsList}
        handleDeleteRequest={handleDelete}
        followers={followers}
        followings={followings}
      />
      {openActionsModal?.state && openActionsModal?.action === "active" && (
        <ActiveModel
          setOpenModel={setOpenActionsModal}
          openModel={openActionsModal}
          handleUpdate={handleUpdateProfileState}
          userType={"customer"}
        />
      )}
      {openActionsModal?.state && openActionsModal?.action === "suspended" && (
        <SuspendModel
          setOpenModel={setOpenActionsModal}
          openModel={openActionsModal}
          handleUpdate={handleUpdateProfileState}
          userType={"customer"}
        />
      )}
      {openActionsModal?.state && openActionsModal?.action === "deleted" && (
        <DeleteModel
          setOpenModel={setOpenActionsModal}
          openModel={openActionsModal}
          handleUpdate={handleUpdateProfileState}
          userType={"customer"}
        />
      )}
    </>
  );
}

export default CustomersPage;
